import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8618d7d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","justify-content":"space-around"} }
const _hoisted_2 = { class: "dialog-footer" }

import BaseEchart from '@/components/BaseEchart.vue';
import { ref, onMounted, watch } from 'vue';
import dayjs from "dayjs";
import { getListData } from "@/service/main/system";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailDialogEnd',
  props: {
    visible: { type: Boolean },
    row: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const closeDialog = () => {
  emit('close');
};

watch(() => props.visible, (newValue) => {
  if (newValue) {
    updateChart();
  }
});

const options = ref<echarts.EChartsOption | null>(null);
const typeOptions = ref<echarts.EChartsOption | null>(null);

const updateChart = () => {
  const activePlans = props.row.activePlans;
  const endPlans = props.row.endPlans;

  const typeA = props.row.typeA;
  const typeB = props.row.typeB;
  const typeC = props.row.typeC;
  const typeD = props.row.typeD;
  const noTag = props.row.communicationPlans - props.row.typeA - props.row.typeB - props.row.typeC - props.row.typeD;

  // 创建一个饼图, 并设置数据, 加个标题
  options.value = {
    title: {
      text: '按是否成交',
      left: 'center'
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b} : {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      left: 10,
      data: ['进行中', '成交']
    },
    series: [
      {
        name: '访问来源',
        type: 'pie',
        avoidLabelOverlap: false,
        label: {
          show: true
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '20',
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: [
          { value: activePlans, name: '进行中' },
          { value: endPlans, name: '成交' }
        ]
      }
    ]
  }

  // 创建一个饼图, 并设置数据
  typeOptions.value = {
    title: {
      text: '按重要程度',
      left: 'center'
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b} : {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      left: 10,
      data: ['A类', 'B类', 'C类', 'D类', '未标记']
    },
    series: [
      {
        name: '访问来源',
        type: 'pie',
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '20',
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: [
          { value: typeA, name: 'A类' },
          { value: typeB, name: 'B类' },
          { value: typeC, name: 'C类' },
          { value: typeD, name: 'D类' },
          { value: noTag, name: '未标记' }
        ]
      }
    ]
  }
};


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "详情",
    modelValue: props.visible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.visible) = $event)),
    width: "60%",
    "max-width": "600px",
    onClose: closeDialog
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, { onClick: closeDialog }, {
          default: _withCtx(() => [
            _createTextVNode("关闭")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (options.value)
          ? (_openBlock(), _createBlock(BaseEchart, {
              key: 0,
              class: "exchangeChart",
              options: options.value,
              width: "500px"
            }, null, 8, ["options"]))
          : _createCommentVNode("", true),
        (typeOptions.value)
          ? (_openBlock(), _createBlock(BaseEchart, {
              key: 1,
              class: "exchangeChart",
              options: typeOptions.value,
              width: "500px"
            }, null, 8, ["options"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})